import {
  describirDiferencia,
  formatearKilosDiferencia,
  formatearPorcentajeDiferencia,
  RESULTADOS_DIFERENCIA,
} from './diferenciaCompraPrevia'

function Cifra({
  etiqueta,
  valor,
  claseValor = 'text-slate-900',
}) {
  return (
    <div className="min-w-0">
      <dt className="text-xs font-semibold uppercase tracking-wide text-slate-400">
        {etiqueta}
      </dt>

      <dd
        className={`mt-1 break-words text-base font-bold tabular-nums sm:text-lg ${claseValor}`}
      >
        {valor}
      </dd>
    </div>
  )
}

// compacta: versión reducida para el formulario de recepción.
function ComparacionKilosCompraPrevia({
  comparacion,
  compacta = false,
  className = '',
}) {
  if (!comparacion?.aplica) return null

  if (comparacion.estado === 'pendiente') {
    return (
      <div
        className={`rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-600 ${className}`}
      >
        <p className="font-semibold text-slate-700">
          Pendiente de recepción
        </p>

        {comparacion.acordadoKg > 0 && (
          <p className="mt-0.5">
            Kilos acordados:{' '}
            {formatearKilosDiferencia(comparacion.acordadoKg)}. La
            diferencia se calculará comparando los kilos acordados contra
            los kilos netos recibidos.
          </p>
        )}
      </div>
    )
  }

  const resultado = RESULTADOS_DIFERENCIA[comparacion.resultado]
  const preliminar = comparacion.estado === 'preliminar'

  return (
    <div
      className={`rounded-xl border p-4 ${resultado.claseCaja} ${className}`}
    >
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <span
          className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${resultado.clase}`}
        >
          {resultado.etiqueta}
        </span>

        <span
          className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${
            preliminar
              ? 'bg-slate-200 text-slate-700'
              : 'bg-slate-800 text-white'
          }`}
        >
          {preliminar ? 'Preliminar' : 'Definitivo'}
        </span>
      </div>

      <p className={`text-sm font-semibold ${resultado.claseTexto}`}>
        {describirDiferencia(comparacion)}
      </p>

      <dl
        className={`mt-3 grid grid-cols-2 gap-3 sm:gap-4 ${
          compacta ? 'sm:grid-cols-4' : 'md:grid-cols-4'
        }`}
      >
        <Cifra
          etiqueta="Kg acordados"
          valor={formatearKilosDiferencia(comparacion.acordadoKg)}
        />

        <Cifra
          etiqueta="Kg netos recibidos"
          valor={formatearKilosDiferencia(comparacion.netoKg)}
        />

        <Cifra
          etiqueta="Neto − acordado"
          valor={formatearKilosDiferencia(comparacion.diferenciaKg, {
            conSigno: true,
          })}
          claseValor={resultado.claseTexto}
        />

        <Cifra
          etiqueta="Neto − acordado %"
          valor={formatearPorcentajeDiferencia(comparacion.porcentaje)}
          claseValor={resultado.claseTexto}
        />
      </dl>

      {comparacion.brutoKg !== null && (
        <p className="mt-3 border-t border-black/5 pt-3 text-sm text-slate-600">
          Peso bruto (informativo):{' '}
          <span className="tabular-nums">
            {formatearKilosDiferencia(comparacion.brutoKg)}
          </span>
          {comparacion.taraKg !== null && (
            <>
              {' · '}
              Tara total:{' '}
              <span className="tabular-nums">
                {formatearKilosDiferencia(comparacion.taraKg)}
              </span>
            </>
          )}
        </p>
      )}

      {comparacion.aceptadosKg !== null && (
        <p className="mt-2 text-sm text-slate-700">
          <span className="font-semibold">
            Kg aceptados para inventario:
          </span>{' '}
          <span className="tabular-nums">
            {formatearKilosDiferencia(comparacion.aceptadosKg)}
          </span>
          {comparacion.rechazoTotal &&
            ' (recepción rechazada totalmente)'}
        </p>
      )}

      {preliminar && (
        <p className="mt-2 text-xs text-slate-500">
          Resultado preliminar: puede cambiar hasta que se valide la
          recepción. Es solo informativo y no modifica monto ni inventario.
        </p>
      )}
    </div>
  )
}

export default ComparacionKilosCompraPrevia
